import { useState } from "react";

import { useMedplumProfile } from "@medplum/react";

import { Flex } from "@mantine/core";
import { createSpotlight } from "@mantine/spotlight";

import { DevelopmentFeatureFlags, useFeature } from "@/feature-flags";
import { getDestinationAudience } from "@/navigation";

import { OmniSearchSpotlight } from "./OmniSearchSpotlight";
import { OmniSearchTrigger } from "./OmniSearchTrigger";

/**
 * The header's search: the trigger plus the Spotlight modal. It renders nothing, and so mounts no
 * Spotlight, registers no hotkey, and makes no lookup, unless the `omni-search` flag is on for the
 * practice and the signed-in profile is staff. Search is for staff only.
 *
 * It reads the profile with `useMedplumProfile` because the header renders outside `ProfileContext`.
 */
export function OmniSearch() {
  const isOmniSearchEnabled = useFeature(DevelopmentFeatureFlags.OmniSearch);
  const profile = useMedplumProfile();

  if (!isOmniSearchEnabled || getDestinationAudience(profile) !== "practitioner") return null;

  return <OmniSearchControls />;
}

function OmniSearchControls() {
  // Each header gets its own store, so the trigger and the modal share state without a global.
  const [[store, { open }]] = useState(() => createSpotlight());

  return (
    <>
      <Flex px="md" flex={1} justify={{ base: "flex-end", sm: "center" }}>
        <OmniSearchTrigger onOpen={open} />
      </Flex>
      <OmniSearchSpotlight store={store} />
    </>
  );
}
